<script setup>
import Select from "primevue/select";
import {ref, onMounted} from "vue";
import {usePage} from "@inertiajs/vue3";
import {route} from "ziggy-js";
import {useI18n} from 'vue-i18n';

const {t} = useI18n();
const page = usePage();
const teams = page.props.teams;
const selectedTeam = ref(null);

const changeTeam = (event) => {
    const currentUrl = new URL(route('admin.dashboard'));
    currentUrl.searchParams.set('change-team', event.value);
    window.location.href = currentUrl.toString();
};

onMounted(() => {
    selectedTeam.value = page.props.team?.id;
});
</script>

<template>
    <div class="mobile-team-selector-wrapper">
        <label class="block text-sm font-medium mb-2">
            {{ t('admin.teams.select_team') }}
        </label>
        <Select
            @change="changeTeam"
            class="w-full mobile-team-selector"
            :placeholder="t('admin.teams.select_team')"
            optionLabel="name"
            option-label="name"
            option-value="id"
            :options="teams"
            v-model="selectedTeam"
        >
            <template #dropdownicon>
                <i class="pi pi-chevron-down"></i>
            </template>
        </Select>
    </div>
</template>

<style scoped>
.mobile-team-selector-wrapper {
    padding: 0.5rem 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
}

.mobile-team-selector-wrapper label {
    color: var(--p-text-color);
    font-weight: 600;
    margin-bottom: 0.5rem;
}

/* Ensure select doesn't overflow */
:deep(.mobile-team-selector) {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
}

/* Make the select look more clickable */
:deep(.mobile-team-selector .p-select) {
    border: 1px solid var(--p-primary-color) !important;
    background: var(--p-surface-0) !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
}

:deep(.mobile-team-selector .p-select:hover) {
    border-color: var(--p-primary-color) !important;
    box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.1) !important;
}

/* Ensure dropdown icon is visible and properly sized */
:deep(.mobile-team-selector .p-select-dropdown) {
    color: var(--p-primary-color) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 2.5rem !important;
    min-width: 2.5rem !important;
}

:deep(.mobile-team-selector .p-select-dropdown .p-icon) {
    font-size: 1.2rem !important;
    color: var(--p-primary-color) !important;
    display: block !important;
}

:deep(.mobile-team-selector .p-select-dropdown .pi) {
    font-size: 1.2rem !important;
    color: var(--p-primary-color) !important;
    display: inline-block !important;
}

:deep(.mobile-team-selector .p-select-trigger-icon) {
    color: var(--p-primary-color) !important;
    font-size: 1.2rem !important;
}

/* Ensure the select has enough padding for the icon */
:deep(.mobile-team-selector .p-select .p-select-label) {
    padding-right: 3rem !important;
}

/* Constrain the dropdown panel to viewport */
:deep(.p-select-overlay) {
    max-width: calc(100vw - 2rem) !important;
    left: 1rem !important;
    right: 1rem !important;
}

/* Dark mode adjustments */
.configurator-dark .mobile-team-selector-wrapper label {
    color: var(--p-text-color);
}

.configurator-dark :deep(.mobile-team-selector .p-select) {
    background: var(--p-surface-50) !important;
    border-color: var(--p-primary-color) !important;
}

.configurator-dark :deep(.mobile-team-selector .p-select-dropdown) {
    color: var(--p-primary-color) !important;
}

.configurator-dark :deep(.mobile-team-selector .p-select-dropdown .pi) {
    color: var(--p-primary-color) !important;
}
</style>

